import { gql } from 'graphql-tag'

/**
 * Query to get the currently authenticated user
 */
export const AUTHENTICATED_USER_QUERY = gql`
  query AuthenticatedUser {
    authenticatedItem {
      ... on User {
        id
        name
        email
        phoneNumber
        role
        shortName
        label
        color
        # The user's access relationships — the companies / lead agencies they're
        # a member of. Drives access-scoped pickers (e.g. the Staff filters) so a
        # non-SysAdmin only ever sees what they can actually reach. navBarTitle is
        # needed so the shared companyLabel shows "navBarTitle - name" (not the
        # shortName fallback) for Lead Agency members.
        companies { id name shortName navBarTitle active }
        leadAgencies { id name shortName active }
      }
    }
  }
`

/**
 * Post-login landing decision, made server-side in one fast trip:
 * messages → follow-ups → calendar (see backend landing.queries.ts).
 * Only asked when the URL carries no explicit redirect.
 */
export const LANDING_ROUTE_QUERY = gql`
  query GetLandingRoute {
    getLandingRoute
  }
`